import { render, staticRenderFns } from "./TransferJciEvent.vue?vue&type=template&id=1a65e860&scoped=true"
import script from "./TransferJciEvent.vue?vue&type=script&lang=js"
export * from "./TransferJciEvent.vue?vue&type=script&lang=js"
import style0 from "./TransferJciEvent.vue?vue&type=style&index=0&id=1a65e860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65e860",
  null
  
)

export default component.exports